import { render, staticRenderFns } from "./COAAddMultiCurrencyAccountTransactionModal.vue?vue&type=template&id=871f102c&scoped=true&"
import script from "./COAAddMultiCurrencyAccountTransactionModal.vue?vue&type=script&lang=js&"
export * from "./COAAddMultiCurrencyAccountTransactionModal.vue?vue&type=script&lang=js&"
import style0 from "./COAAddMultiCurrencyAccountTransactionModal.vue?vue&type=style&index=0&id=871f102c&prod&lang=less&scoped=true&"
import style1 from "./COAAddMultiCurrencyAccountTransactionModal.vue?vue&type=style&index=1&id=871f102c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871f102c",
  null
  
)

export default component.exports